import { useQuery } from '@apollo/client'
import { ErrorComponent, ProgressSpinner } from '@medical/components'
import { onPageChange } from '@medical/libs'
import { useCustom } from '@medical/provider/context'
import queryString from 'query-string'
import React from 'react'
import { Router } from 'react-router-dom'

import { ACTIVITY_LOGS_STAFF_HISTORY } from './ActivityLogsStaffHistory.graphql'
import ActivityLogsStaffHistoryScene from './ActivityLogsStaffHistoryScene'

const ActivityLogsStaffHistory = ({ history, location: { search } }) => {
  const [{ i18n }] = useCustom()
  const {
    page = 1,
    rowsPerPage = 20,
    orderBy = 'createdAt_DESC',
    staffId,
  } = queryString.parse(search)
  const first = parseInt(rowsPerPage, 10)
  const skip = (parseInt(page, 10) - 1) * parseInt(rowsPerPage, 10)
  const variables = {
    first: first < 0 ? 20 : first,
    skip: skip < 0 ? 0 : skip,
    orderBy,
    where: {
      Staff: {
        id: staffId,
      },
      activity_in: [
        'LOGGED_STAFF',
        'STAFF_DISPLAYED_SHIFT_LIST',
        'STAFF_DISPLAYED_DOCTOR_LIST',
        'STAFF_OPEN_IDENTITY_NUMBER_SCREEN',
        'STAFF_EXPORT_CSV_IDENTITY_NUMBER',
      ],
    },
  }

  const { loading, error, data } = useQuery(ACTIVITY_LOGS_STAFF_HISTORY, {
    variables,
    fetchPolicy: 'network-only',
  })

  if (loading) return <ProgressSpinner />
  if (error) return <ErrorComponent error={error} />

  const {
    activityLogsConnection: {
      edges,
      aggregate: { count },
    },
    staffs,
  } = data

  const onSearch = ({ staff }) => {
    history.push({
      pathname: Router.staffActivityLogsListDoctorHistory,
      search: queryString.stringify({
        rowsPerPage,
        staffId: staff ? staff.id : undefined,
      }),
    })
  }
  const newStaffs = staffs.map(staff => ({
    ...staff,
    fullNameEmail: `${staff.lastname} ${staff.firstname} (${staff.email})`,
    fullName: `${staff.lastname} ${staff.firstname}`,
    fullNameKana: `${staff.lastnameKana} ${staff.firstnameKana}`,
  }))

  return (
    <ActivityLogsStaffHistoryScene
      i18n={i18n}
      edges={edges}
      staffs={newStaffs}
      rowsPerPage={parseInt(rowsPerPage, 10)}
      page={page}
      count={count}
      staffId={staffId}
      onPageChange={onPageChange(history, search)}
      onSearch={onSearch}
    />
  )
}

export default ActivityLogsStaffHistory
